export const FAQ_DATA = {
  'pdf-to-word': [
    {
      q: "Is the PDF to Word conversion accurate?",
      a: "Yes, our tool uses advanced parsing technology to maintain the layout, fonts, and tables of your original PDF in the converted DOCX file."
    },
    {
      q: "Can I convert scanned PDFs to editable Word documents?",
      a: "Yes, you can enable the OCR (Optical Character Recognition) option to extract text from scanned documents and images."
    },
    {
      q: "Is it safe to upload my private documents?",
      a: "Absolutely. We process all files in-memory and delete them immediately after conversion. Your data is never stored or shared."
    }
  ],
  'compress-pdf': [
    {
      q: "Will compressing my PDF reduce the quality of images?",
      a: "You can control the quality using our quality slider. At 80% quality, most users see a significant file size reduction with no visible loss in image clarity."
    },
    {
      q: "How much can I reduce my PDF file size?",
      a: "The reduction depends on the original content. PDFs with many high-resolution images can often be reduced by 50-90%."
    }
  ],
  'word-to-pdf': [
    {
      q: "Will the formatting of my Word document change?",
      a: "No, our converter ensures that all fonts, margins, and layouts are preserved perfectly in the resulting PDF."
    },
    {
      q: "Does this tool support .doc and .docx formats?",
      a: "Yes, we support both the older .doc and the modern .docx Microsoft Word formats."
    }
  ],
  'image-to-pdf': [
    {
      q: "Can I combine multiple images into one PDF?",
      a: "Currently, our tool supports converting one image per PDF. For multiple images, we recommend converting them individually and then using a merge tool."
    },
    {
      q: "What image formats are supported?",
      a: "We support JPG, PNG, WEBP, and AVIF formats."
    }
  ],
  'pdf-to-image': [
    {
      q: "What image format will I get?",
      a: "This tool extracts each page of your PDF as a high-quality PNG image and packages them into a single ZIP file for easy download."
    },
    {
      q: "Can I choose the resolution of the images?",
      a: "Yes, you can select the 300 DPI option for high-resolution images suitable for printing."
    }
  ],
  'organize-pdf': [
    {
      q: "How do I reorder pages in my PDF?",
      a: "After uploading your PDF, simply drag and drop the page thumbnails to your desired order. Click Convert when you're finished to save the new sequence."
    },
    {
      q: "Can I delete pages while organizing?",
      a: "Yes, each page thumbnail has a trash icon. Clicking it will remove that specific page from the final document."
    },
    {
      q: "Can I add pages from other PDF files?",
      a: "Absolutely! Click the 'Add more files' button to upload additional PDFs. All pages will appear in the grid, and you can interleave them as you like."
    }
  ],
  'remove-pdf-pages': [
    {
      q: "How do I remove pages from a PDF?",
      a: "Simply upload your PDF, click on the pages you want to delete (they will be marked with a trash icon), and click the Convert button to download your modified PDF."
    },
    {
      q: "Can I remove multiple pages at once?",
      a: "Yes, you can select as many pages as you want to remove. The resulting PDF will only contain the pages you didn't select."
    },
    {
      q: "Is it possible to undo a page removal?",
      a: "Before clicking Convert, you can click a selected page again to unmark it. Once converted, you would need to re-upload the original file."
    }
  ],
  'default': [
    {
      q: "Is this tool free to use?",
      a: "Yes, all conversion tools on Convert All Docs are 100% free with no hidden costs or signup requirements."
    },
    {
      q: "Do I need to install any software?",
      a: "No, everything happens in your web browser. You don't need to install any plugins or desktop applications."
    },
    {
      q: "Is my data secure?",
      a: "Security is our priority. We use HTTPS encryption for all transfers and delete files immediately after processing."
    }
  ]
};
